import { Directive, Input, ElementRef, Inject } from '@angular/core';
@Directive({
  selector: '[subFocus]',
})
export class SubFocusDirective {
  @Input() subFocus: boolean = false;
  constructor(@Inject(ElementRef) private element: ElementRef) {}
  protected ngOnChanges() {
    if (this.subFocus == true) {
      this.element.nativeElement.focus();
    }
  }
}
